// extracted by mini-css-extract-plugin
export default {"container":"EmailSummaryInfo_container__EXVFg","infoText":"EmailSummaryInfo_infoText__5GySR","infoValue":"EmailSummaryInfo_infoValue__PCb8i"};